/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Read_AllInputs */

const en_notifications_read_all = /** @type {(inputs: Notifications_Read_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read all`)
};

const pl_notifications_read_all = /** @type {(inputs: Notifications_Read_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeczytaj wszystkie`)
};

/**
* | output |
* | --- |
* | "Read all" |
*
* @param {Notifications_Read_AllInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const notifications_read_all = /** @type {((inputs?: Notifications_Read_AllInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Read_AllInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_notifications_read_all(inputs)
	return en_notifications_read_all(inputs)
});